<template>
    <div class="news">
        <headers :title="$t('新闻中心')" img="newsCenter"></headers>
        <el-row :gutter="20">
            <el-col :span="3" :offset="5"><div class="btn InternationalBtn"> <router-link to="/news">{{$t('新闻动态')}}</router-link></div></el-col>
            <el-col :span="3"><div class="btn domesticBtn"><router-link to="/videoCenter">{{$t('视频中心')}}</router-link> </div></el-col>
        </el-row>
        <div class="line"></div>
        <el-row :gutter="20">
            <el-col :span="3" :offset="5"><div class="year">2020</div></el-col>
        </el-row>
        <newsItem @click.native="goInfo(item.id)" :newsData="item" v-for="(item, index) in newsData" :key="index"></newsItem>      
        <foot style="margin-top:5rem"></foot>        
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
import newsItem from "@/components/newsItem.vue";
import {getNewsData} from "../datas/newsData.js"
import {getAllNews} from '../datas/ajax'
export default {
    components:{
      headers,foot,newsItem
    },
    created(){
        this.render()
    },
    data() {
        return {
            newsData:[],
        }
    },
    watch: {
        '$route' (to, from) {
            this.render()
        },
        '$i18n.locale'(){
            this.render()
        },
    },
    methods:{
        render(){
            getAllNews((data)=>{
                this.newsData = data
                // this.newsData = getNewsData()
            })
        },
        goInfo(index){
            this.$router.push('/newsDetails/'+index)
            document.getElementById("app").scrollIntoView();
        }
    }
}
</script>
<style lang="less">
.news{
    .btn{
        line-height: 3rem;
        font-size: 0.8rem;
        cursor: pointer;
    }
    .domesticBtn a{
        color: #A0A0A0;  
        text-decoration: none;      
    }
    .InternationalBtn a{
        color: #565656;
        text-decoration: none;
    }
    .line{
        height: 1px;
        width: 100%;
        background-color: #BFBFBF;
    }
    .year{
        font-size: 1rem;
        color: #888888;
        line-height: 5rem;
    }

}
</style>
<i18n>
{
  "en": {
       "新闻动态":"News",
       "视频中心":"Video Center",
       "新闻中心":"News Center"
  },
  "zh": {
       "新闻动态":"新闻动态", 
       "视频中心":"视频中心",
       "新闻中心":"新闻中心"
    }
}
</i18n>
